import { useEffect } from 'react'

const useResponsiveContent = ({ offset = 0 }) => {
  const componentSelector =
    '.boxContainer, ' +
    ":not(.flex-grid) > .p-datatable:not([data-disable-autoheight='true']), " +
    ":not(.flex-grid) > .p-datatable:not([data-disable-autoheight='true']) > .p-datatable-wrapper, " +
    ":not(.flex-grid) > .p-datatable:not([data-disable-autoheight='true']) > .p-datatable-wrapper > .p-datatable-body"

  const resize = () => {
    if (
      !document.querySelector('.component-data') ||
      window.innerWidth < 1200 /*$media-medium-land*/
    ) {
      document.querySelectorAll(componentSelector)?.forEach((componentData) => {
        // componentData.style["max-height"] = "100vh"
        // componentData.style.height = "100vh"
        componentData.style['max-height'] = '100%'
        componentData.style.height = '100%'
      })
      return
    }

    const headerViews = document.querySelectorAll('.header-menu')
    let mainHeaderHeight = 0
    headerViews.forEach((header) => {
      mainHeaderHeight += header.clientHeight || 0
    })
    const footerHeight =
      document.querySelector('.paginator-container')?.clientHeight || 0
    const viewsContainerHeight =
      document.querySelector('.viewsContainer')?.clientHeight || 0
    const mainViewHeight =
      document.querySelector('.main-common-view:not(.disable-autoheight)')
        ?.clientHeight || 0
    const marginHeight = 8 * headerViews.length
    const calcOffset = mainViewHeight - (mainHeaderHeight + marginHeight)

    // console.log(
    //     "useResponsiveContent",
    //     "window.innerWidth",
    //     window.innerWidth,
    //     "mainViewHeight",
    //     mainViewHeight,
    //     "headerViews.length",
    //     headerViews.length,
    //     "offset",
    //     offset,
    //     "footerHeight",
    //     footerHeight,
    //     "mainHeaderHeight",
    //     mainHeaderHeight,
    //     calcOffset
    // );

    document.querySelectorAll(componentSelector)?.forEach((componentData) => {
      let dtheaderHeight = 0
      if (componentData?.parentElement?.querySelector('.p-datatable-header')) {
        dtheaderHeight =
          componentData?.parentElement?.querySelector('.p-datatable-header')
            ?.clientHeight || 0
        if (dtheaderHeight > 0)
          dtheaderHeight += 10 /* 0.5rem + 1px border x 2 */
      }

      const autoheightOffset =
        componentData?.parentElement?.getAttribute('data-autoheight-offset') ||
        0

      const finalCalculatedHeight =
        Number(calcOffset) -
        (Number(dtheaderHeight) + Number(autoheightOffset)) +
        'px'

      componentData.style['max-height'] = finalCalculatedHeight
      // componentData.style["background-color"] = "blue"
      componentData.style.height = finalCalculatedHeight
    })

    // disable-autoheight full height
    document
      .querySelectorAll(
        '.main-common-view.disable-autoheight > .component-data > .boxContainer',
      )
      .forEach((componentData) => {
        componentData.style['min-height'] = viewsContainerHeight - 197 + 'px'
      })
  }

  resize()

  useEffect(() => {
    resize() // Call resize on component mount
    ;['load', 'resize'].forEach((e) => {
      window.addEventListener(e, resize)
    })
    // window.addEventListener("load resize", resize);0
    return () => {
      ;['load', 'resize'].forEach((e) => {
        window.removeEventListener(e, resize)
      })
      // window.removeEventListener("resize", resize);
    }
  }, [])
}

export default useResponsiveContent
